import { AppDispatch, RootState } from "src/Store/store";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { IqueryParams } from "src/types/GlobalInterfaces";
import { IPaginated } from "src/types/paginated";
import httpRequest from "src/helpers/httpRequest";
import qs from "qs";
import { toast } from "react-toastify";
import CustomerTableWrapper from "../Customer/CustomerTableWrapper";
import { faDownload, faEye, faSpinner } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import parchiIcon from "src/assets/images/no-parchi-icon.png";
import moment from "moment";
import { updateRedDots } from "src/Store/redDots";

interface IPrescribedResponse {
  [key: string]: any;
}
interface IPrescribedItem {
  IPrescribedItem?: string;
  [key: string]: any;
}

const AllCustomerReports = ({ customerID }: { customerID: string }) => {
  const { userDetails } = useSelector((store: RootState) => store?.appReducer);
  const [isLoader, setIsLoader] = useState<boolean>(false);
  const [reportsData, setReportsData] = useState<IPrescribedItem>([]);
  const [loading, setLoading] = useState<string | null>(null);

  const [paginated, setPaginated] = useState<IPaginated>({
    currentPage: 1,
    totalPages: 1,
  }); 
  const [queryParams, setQueryParams] = useState<IqueryParams>({
    page: 1,
    limit: 10,
    search: "",
    startDate: "",
    endDate: "",
    customerId: customerID || "",
    doctorId: userDetails?._id || "",
  }); 
  const dispatch = useDispatch<AppDispatch>();

  const FetchPrescibedData = async (q: IqueryParams) => {
    setIsLoader(true);
    const { res, err } = await httpRequest<IPrescribedResponse>({
      path: `/appoiment/all-Reports?${qs.stringify(q)}`,
    });
    if (res) {
      const { documents = [], paginated } = res;
      console.log("Reports Data ===>", documents);
      setReportsData(documents);
      setPaginated(paginated);
      dispatch(updateRedDots({ reportNotified: 0 })); // reset report notified
    } else {
      toast(err, { type: "error" });
    }
    setIsLoader(false);
  };

  const handleChangeQuery = (
    data: Partial<IqueryParams>,
    resetPage: boolean = true
  ) => {
    let newQuery = {
      ...queryParams,
      ...data,
    };
    if (resetPage) {
      newQuery.page = 1;
      setReportsData([]);
    }
    setQueryParams(newQuery);
    FetchPrescibedData(newQuery);
  };

  const downloadReport = async (report: string , id: string) => {
    try {
      setLoading(id);
      const response = await fetch(report);
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      
      const blob = await response.blob();
      
      
      const blobUrl = window.URL.createObjectURL(blob);
      
      
      const link = document.createElement("a");
      link.href = blobUrl;
      link.download = `report_${Date.now()}.${blob.type.split("/")[1]}`; 
      link.target = "_blank";
      
      
      document.body.appendChild(link);
      link.click();
      
      
      document.body.removeChild(link);
      window.URL.revokeObjectURL(blobUrl); 
    } catch (error) {
      console.error('Download failed:', error);
      toast.error("Failed to download report. Please try again.");
    } finally {
      setLoading(null);
    }
  };

  useEffect(() => {
    handleChangeQuery({ page: 1 });
  }, []);
  return (
    <CustomerTableWrapper
      isLoading={isLoader}
      thead={["Image", "Date", "Action"]}
      page={paginated.currentPage || 1}
      total={paginated.totalPages || 0}
      columnWidth={"70% 20% 10%"}
      onChange={(page: number) => handleChangeQuery({ page })}
    >
      {reportsData.length > 0 ? (
        reportsData?.map((item: any, index: number) => (
          <ul
            key={index}
            className="font-size-16px tbody-light-table customer-table-wrapper-body-padding-non customer-table-wrapper-body tbody-light-table-customer font-Poppins-Regular grid"
            style={{ gridTemplateColumns: "70% 20% 10%" }}
          >
            <li className="!px-7">
              <img
                src={item?.report || ""}
                alt="report"
                className="w-[50px] aspect-square border object-cover"
              />
            </li>
            <li>{moment(item?.createdAt).format("DD-MM-YYYY") || ""}</li>
            <li className="flex items-center gap-2 justify-end">
              <button
                type="button"
                className="flex items-center !rounded-sm justify-center text-gray-500 cursor-pointer"
                onClick={() => downloadReport(item?.report, item?._id)}
                id={`download-report-${index + 1}`}
                disabled={loading === item?._id}
              >
                <FontAwesomeIcon
                  icon={loading === item?._id ? faSpinner : faDownload}
                  className={`text-theme-color-green font-size-16px ${loading === item?._id ? "animate-spin" : ""}`}
                />
              </button>
            </li>
          </ul>
        ))
      ) : (
        <ul className="font-size-16px tbody-light-table font-Poppins-Regular grid">
          <li className="parchi-icon-order">
            <img src={parchiIcon} alt="" />
            <span className="font-size-22px font-Poppins-Medium">
              No Records Found
            </span>
          </li>
        </ul>
      )}
    </CustomerTableWrapper>
  );
};

export default AllCustomerReports;
